let emailConfig = {
  emailjs: {
    serviceID: "portfolio-template",
    templateID: "template_tn20iks",
    userID: "TNNbayXIRCLBUk5MK"
  }
};

export default emailConfig;
